import { Tab } from '../ui';
import { PageProps } from './index';

export function Features(props: PageProps) {
  const { setShowPage } = props;

  const features: Array<{
    key: 'assets' | 'places' | 'contacts';
    title: string;
    description: string;
    onClick?: () => void;
  }> = [
    {
      key: 'assets',
      title: 'Assets',
      description: 'Manage available Asset types and sub-navigation.',
      onClick: () => setShowPage('assetTypes'),
    },
    {
      key: 'places',
      title: 'Places',
      description: 'Manage available Place types and sub-navigation.',
      onClick: () => setShowPage('placeTypes'),
    },
    {
      key: 'contacts',
      title: 'Contacts',
      description: 'Manage available Contact types and sub-navigation.',
      onClick: () => setShowPage('contactTypes'),
    },
  ];

  return (
    <div className='flex flex-col gap-2'>
      <div className='mb-2'>
        <p className='text-secondary'>
          Enable and customize available features.
        </p>
      </div>
      <div className='flex flex-col'>
        {features.map((f) => (
          <Tab
            key={f.key}
            title={f.title}
            description={f.description}
            onClick={f.onClick}
          />
        ))}
      </div>
    </div>
  );
}
